import { render, staticRenderFns } from "./PaymentCommission.vue?vue&type=template&id=e07020b0&scoped=true&"
import script from "./PaymentCommission.vue?vue&type=script&lang=js&"
export * from "./PaymentCommission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e07020b0",
  null
  
)

export default component.exports